<p></p>
<p>Hier befinden Sie sich im neuen WEB-VA.</p>
<p>In nächster Zeit werden etappenweise alle Funktionen des alten WEB-VA in die neue Anwendung migriert.</p>

<!-- Termine anzeigen -->

@if (termine().length > 0) {
  <div class="m-4">
    <div class="buttonLeiste">Termine für 3 Monate</div>
    <div class="mt-2">
      <ui-custom-kendo-grid
        [data]="termine()"
        gridId="e2b50f97-a596-4c86-a45f-2ef0bf186336"
        id="my-grid"
        [rowCallback]="rowCallback"
        (cellClick)="termineAnzeigen($event)"
        [columns]="[
          { field: 'bereich', title: 'Bereich', width: 80 },
          { field: 'erinnerung', title: 'Erinnerung', width: 40, type: 'date', format: 'dd.MM.yyyy' },
          { field: 'bezeichnung', title: 'Bezeichnung', width: 250, html: true },
        ]"
      >
      </ui-custom-kendo-grid>
      <div class="m-2">
        <b>Farben:</b>
        <span class="gridgruen m-2 p-1">Aktuell</span>
        <span class="gridrot m-2 p-1">Abgelaufen</span>
        <span class="gridgelb m-2 p-1">Einträge des aktuellen Tages</span>
      </div>
    </div>
  </div>
}
